import { render, staticRenderFns } from "./CommodityCostAdjustList.vue?vue&type=template&id=0b7910e7&scoped=true"
import script from "./CommodityCostAdjustList.vue?vue&type=script&lang=js"
export * from "./CommodityCostAdjustList.vue?vue&type=script&lang=js"
import style0 from "./CommodityCostAdjustList.vue?vue&type=style&index=0&id=0b7910e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7910e7",
  null
  
)

export default component.exports